export default {"src":"/_next/static/media/googleplayFr.1174ea88.svg","height":40,"width":135,"blurWidth":0,"blurHeight":0};